function initHatitudeAttitude(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const tabs = [...root.querySelectorAll('[data-hc-tab]')];
  const panels = [...root.querySelectorAll('[data-hc-panel]')];
  root.querySelector('[data-hc-tabs]').setAttribute('role', 'tablist');
  const select = (index, focus = false) => {
    tabs.forEach((tab, i) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      panels[i].setAttribute('role', 'tabpanel');
      panels[i].hidden = i !== index;
    });
    if (focus) tabs[index].focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); select(next, true); }
    });
  });
  if (tabs.length) select(0);
}
document.querySelectorAll('[data-hc-attitude]').forEach(initHatitudeAttitude);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hc-attitude]').forEach(initHatitudeAttitude));
function initHatitudeSticky() {
  const bar = document.querySelector('sticky-add-to-cart');
  if (!bar) return;
  const page = document.getElementById(bar.dataset.id);
  const sync = () => {
    const main = page?.querySelector('[data-main-product-add-to-cart]');
    const button = bar.querySelector('[data-js-atc]');
    if (!main || !button) return;
    button.disabled = main.disabled || main.classList.contains('disabled') || main.classList.contains('working');
    const label = main.querySelector('[data-js-product-add-to-cart-text]');
    if (label) button.querySelector('.button__text').textContent = label.textContent.trim();
  };
  sync();
  if (page) new MutationObserver(sync).observe(page, {subtree:true,childList:true,attributes:true,attributeFilter:['class','disabled']});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHatitudeSticky); else initHatitudeSticky();
function initHatitudeCollection(){
 const tools=document.querySelector('[data-hc-collection-tools]');
 if(!tools)return;
 const grid=document.getElementById('main-collection-product-grid');
 if(!grid)return;
 const cards=[...grid.querySelectorAll('[data-hc-title]')];
 const priceSelect=tools.querySelector('[data-hc-price-filter]');
 const amounts=[...new Set(cards.flatMap(card=>[Number(card.dataset.hcPrice),...[...card.querySelectorAll('[data-hc-swatch]')].map(s=>Number(s.dataset.price))]).filter(n=>Number.isFinite(n)&&n>0))].sort((a,b)=>a-b);
 const priceKey=amounts.join(',')+'|'+(cards[0]?.dataset.hcCurrency||'SEK');
 if(priceSelect.dataset.prices!==priceKey){
  const selected=priceSelect.value;
  while(priceSelect.options.length>1)priceSelect.remove(1);
  amounts.forEach(amount=>{const option=document.createElement('option');option.value=String(amount);const money=new Intl.NumberFormat(document.documentElement.lang||'sv-SE',{style:'currency',currency:cards[0]?.dataset.hcCurrency||'SEK'}).format(amount/100);option.textContent=priceSelect.dataset.upTo.replace('__PRICE__',money);priceSelect.append(option);});
  priceSelect.value=amounts.includes(Number(selected))?selected:'0';priceSelect.dataset.prices=priceKey;
 }
 if(!tools.dataset.attitudeInitialized){const desired=new URLSearchParams(location.search).get('hatitude_attitude');if(['antisocial','country','bad'].includes(desired))tools.querySelector('[data-hc-attitude-filter]').value=desired;tools.dataset.attitudeInitialized='true';}
 const filter=()=>{
  const attitude=tools.querySelector('[data-hc-attitude-filter]').value;
  const price=Number(tools.querySelector('[data-hc-price-filter]').value);
  const groups={antisocial:/hatar|people suck|helvete|dra åt/i,country:/fölk|folk dreck|hunting|skog|träskor|whiskey|byfåne|bättre förr/i,bad:/dick|pussy|matilda|storkuk|hängpatt|dicktits|kidnap|boob/i};
  let count=0;
  cards.forEach(card=>{
   const prices=[...card.querySelectorAll('[data-hc-swatch]')].map(s=>Number(s.dataset.price));
   const minimum=prices.length?Math.min(...prices):Number(card.dataset.hcPrice);
   card.hidden=(attitude!=='all'&&!groups[attitude].test(card.dataset.hcTitle))||(price>0&&minimum>price);
   if(!card.hidden)count++;
  });
  const status=tools.querySelector('[data-hc-design-count]');
  status.textContent=count+' '+status.dataset.suffix;
  document.querySelectorAll('[data-hc-grouped-count]').forEach(node=>{node.textContent=status.dataset.countTemplate.replace('__COUNT__',String(count));});
 };
 if(!tools.dataset.ready){tools.dataset.ready='true';tools.addEventListener('change',()=>initHatitudeCollection());}
 cards.forEach(card=>{
  if(card.dataset.hcReady)return;
  card.dataset.hcReady='true';
  card.querySelectorAll('[data-hc-swatch]').forEach(swatch=>swatch.addEventListener('click',event=>{
   if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
   event.preventDefault();
   card.querySelectorAll('[data-hc-swatch]').forEach(s=>s.dataset.selected=String(s===swatch));
   card.querySelectorAll('a:not([data-hc-swatch])').forEach(link=>link.href=swatch.href);
   const image=card.querySelector('.rv-card-model');
   if(image){image.src=swatch.dataset.image||swatch.dataset.model;image.style.objectFit='contain';}
   let person=card.querySelector('.hc-card-person');
   if(swatch.dataset.person){if(!person){person=document.createElement('img');person.className='hc-card-person';person.alt=card.dataset.hcTitle||'';person.loading='lazy';person.decoding='async';image?.parentElement.appendChild(person);}person.src=swatch.dataset.person;person.hidden=false;}else if(person){person.hidden=true;}
   const price=card.querySelector('.product-price--original');
   if(price)price.textContent=new Intl.NumberFormat(document.documentElement.lang||'sv-SE',{style:'currency',currency:card.dataset.hcCurrency||'SEK',maximumFractionDigits:0}).format(Number(swatch.dataset.price)/100);
   card.dataset.hcPrice=swatch.dataset.price;
   card.dataset.hcSelectedColor=swatch.getAttribute('aria-label');
  }));
 });
 filter();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initHatitudeCollection);else initHatitudeCollection();
document.addEventListener('shopify:section:load',initHatitudeCollection);
const hcCollectionRoot=document.querySelector('[id*="__collection"]');
if(hcCollectionRoot)new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1)))initHatitudeCollection();}).observe(hcCollectionRoot,{childList:true,subtree:true});


